import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/cross-platform.svg
 */
const IconCrossPlatform: IconComponent = ({
  size = 24,
  color = '#E2E2E2',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M16.302 16.257H2.38a.9.9 0 01-.621-.249.828.828 0 01-.258-.597V4.343c0-.223.092-.438.258-.596a.898.898 0 01.621-.247h16.03c.234 0 .457.089.622.247a.826.826 0 01.257.596v6.555h-2.986v5.359zM2.38 4.185a.162.162 0 00-.117.046.152.152 0 00-.05.113V15.41c0 .043.019.084.05.114.031.03.073.047.117.047H15.59v-4.705a.626.626 0 01.197-.459.682.682 0 01.48-.19h2.309v-5.87a.159.159 0 00-.05-.111.173.173 0 00-.117-.047L2.38 4.185z"
      fill="currentColor"
    />
    <path
      d="M12.329 18.837H8.458v-3.264h3.87v3.264zm-3.157-.685h2.44v-1.894h-2.44v1.894z"
      fill="currentColor"
    />
    <path
      d="M13.756 18.152h-6.73v.685h6.73v-.685zM15.945 13.438H1.855v.685h14.09v-.685z"
      fill="currentColor"
    />
    <path
      d="M21.823 20.5h-5.558a.697.697 0 01-.48-.191.636.636 0 01-.197-.46v-8.988c0-.172.07-.337.197-.458.127-.122.3-.19.48-.19h5.56a.704.704 0 01.478.19.644.644 0 01.197.458v8.989a.645.645 0 01-.417.6.702.702 0 01-.26.05zm-5.52-.685h5.481v-8.917h-5.482v8.917z"
      fill="currentColor"
    />
    <path
      d="M19.716 11.365h-1.344v.685h1.344v-.685zM22.143 17.5h-6.198v.686h6.198V17.5zM19.716 18.665h-1.344v.685h1.344v-.685zM9.79 6.905H5.212v.685h4.576v-.685z"
      fill="currentColor"
    />
    <path
      d="M6.541 9.005L4.708 7.25l1.833-1.757.505.484L5.719 7.25 7.046 8.52l-.505.484zM12.495 10.17H7.918v.686h4.577v-.685z"
      fill="currentColor"
    />
    <path
      d="M11.167 12.274l-.503-.484 1.325-1.272-1.325-1.272.503-.485 1.835 1.757-1.835 1.756z"
      fill="currentColor"
    />
  </svg>
);

export default IconCrossPlatform;
